module.exports = __webpack_public_path__ + "media/icons/rodzaj-paliwa@2x-42c34322.png";